export const FLAG_GETTING_ACTIVITY_TASK_EXECUTIONS =
  'FLAG_GETTING_ACTIVITY_TASK_EXECUTIONS';
export const GET_ACTIVITY_TASK_EXECUTIONS = 'GET_ACTIVITY_TASK_EXECUTIONS';
export const CLEAR_ACTIVITY_TASK_EXECUTIONS = 'CLEAR_ACTIVITY_TASK_EXECUTIONS';
export const FLAG_ACTIVITY_TASK_EXECUTION_ACTIVITY =
  'FLAG_ACTIVITY_TASK_EXECUTION_ACTIVITY';
export const GET_ACTIVITY_TASK_EXECUTION = 'GET_ACTIVITY_TASK_EXECUTION';
export const CLEAR_ACTIVITY_TASK_EXECUTION = 'CLEAR_ACTIVITY_TASK_EXECUTION';
